export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const STORE_DECODED_USER_INFO = 'STORE_DECODED_USER_INFO';
export const USER_LOGIN_FAILED = 'USER_LOGIN_FAILED';
